/**
 * Whether the product may say a scope cannot be read.
 *
 * A walk over a scope with no live content-reader grant is accepted, opens no
 * file, and reports nothing. `listContentReaderGrants` answers that directly,
 * so the only judgement left is what counts as a definite no - and it is a
 * narrow one. "We could not ask" and "the answer is no" send an operator to two
 * different places, so an unanswered or failed read says nothing at all.
 *
 * This lived as an expression inside the page and as a copy of itself inside a
 * test, which is the arrangement where a test passes while the screen is wrong.
 */
export interface Grant {
  bucketId: string;
  granted: boolean;
  grantedAt?: string | null;
  revokedAt?: string | null;
}

export function noReadGrant(
  state: 'success' | 'pending' | 'error',
  grants: readonly Grant[],
  bucketId: string | undefined,
): boolean {
  if (state !== 'success' || !bucketId) return false;
  const mine = grants.find((g) => g.bucketId === bucketId);
  return mine !== undefined && mine.granted === false;
}
